import React, {useEffect} from "react";
import { useQuery } from "react-query";
import SpecialDealsBanner from "../../components/special-deals/special-deals-banner";
import ViewAllCards from "./view_all-card";
import { SPECIALDEALSHOME_URL } from '../../services/common/endpoints';
import { GetCacheKey } from "../../services/common/utils";
import {GTMScreenView} from "../../../src/analytics/GoogleTagManager";
import {useSelector} from "react-redux";
import {CT_Events} from "../../../src/analytics/CTEvents";

const SpecialDealsViewAll = () => {
  
  const {
    data: { data } = {},
    isLoading,
    error,
    isFetching,
    isError,
    isLoadingError,
    isSuccess,
  } = useQuery(
    [
      GetCacheKey("special-deals-viewall"),
      SPECIALDEALSHOME_URL.url,
      SPECIALDEALSHOME_URL.data,
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 0,
      staleTime: 0,
    }
  );
  const {CT_ScreenView} = CT_Events();
  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const msisdn = useSelector((state) => state?.userdata?.value?.selectedmsisdn);
  useEffect(()=>{
    try{
      GTMScreenView("Special_Deals_Viewall", msisdn, logintype );
    }catch{}
    try{
      CT_ScreenView();
    }catch{}
  }, [])
  const getPageComponents = (item) => {
    switch (item?.templatetype) {
      // Banner
      case "109": {
        return <SpecialDealsBanner psmItem={item}></SpecialDealsBanner>;
      }
      // Components
      case "112": {
        return <ViewAllCards dataList={item} ></ViewAllCards>;
      }

      default: {
        return <></>;
      }
    }
  };
  return (
    <>
      {data?.data?.map((item) => {
        return <>{getPageComponents(item)}</>;
      })}
    </>
  );
};
export default SpecialDealsViewAll;
